import React, { Children, useContext } from 'react';
import { BiSort as Sortable } from 'react-icons/bi';
import {
  BsSortDownAlt as SortGenericAlt,
  BsSortDown as SortGeneric,
  BsSortAlphaDownAlt as SortAlphaAlt,
  BsSortAlphaDown as SortAlpha,
  BsSortNumericDownAlt as SortNumericAlt,
  BsSortNumericDown as SortNumeric
} from 'react-icons/bs';
import { TableContext } from './TableContext';

const Header = ({ children }) => {
  const context = useContext(TableContext);
  return <thead><tr className={(!context.hover) ? 'no-hover' : ''}>
    {Children.toArray(children).map(child => {
      if (child.sortable) {
        context.setSortableColumns(child.sortKey);
      }
      return child
    })}
  </tr></thead>
}

const HColumn = (props) => {
  const context = useContext(TableContext);
  const onSort = () => (props.sortable) ? context.setOrderBy(props.sortKey) : null;
  return (<th onClick={onSort} className={props.className}>
    <div>
      <span>{props.children}</span>
      {(props.sortable) && <Sort direction={(context?.options?.orderBy === props.sortKey) ? context?.options?.orderDirection : null} ascIcon={<SortGenericAlt />} descIcon={<SortGeneric />} />}
    </div>
  </th>)
}

const HGeneric = ({ children, sortable, direction, onClick }) => <th onClick={onClick}>
  <div>
    {children}
    {(sortable) && <Sort direction={direction} ascIcon={<SortAlphaAlt />} descIcon={<SortAlpha />} />}
  </div>
</th>

const HText = ({ children, sortable, direction, onClick }) => <th onClick={onClick}>
  <div>
    {children}
    {(sortable) && <Sort direction={direction} ascIcon={<SortAlphaAlt />} descIcon={<SortAlpha />} />}
  </div>
</th>

const HNumeric = ({ children, sortable, direction, onClick }) => <th onClick={onClick}>
  <div>
    {children}
    {(sortable) && <Sort direction={direction} ascIcon={<SortNumericAlt />} descIcon={<SortNumeric />} />}
  </div>
</th>

const Sort = ({ direction, ascIcon, descIcon }) => {
  if (!!direction) {
    return (direction === 'desc') ? descIcon : ascIcon;
  } else {
    return <Sortable />;
  }
}

Header.Column = HColumn;
Header.Generic = HGeneric;
Header.Text = HText;
Header.Numeric = HNumeric;

export { Header };